import Skeleton from '@mui/material/Skeleton';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';

type TableRowsLoaderProps = {
  pageSize?: number;
  columns?: number;
};

const TableRowsLoader = ({
  pageSize = 10,
  columns = 3,
}: TableRowsLoaderProps) => {
  return (
    <TableBody data-testid="table-rows-loader">
      {[...Array(pageSize)].map((_, index) => (
        <TableRow key={index}>
          {Array.from({ length: columns }).map((_, colIndex) => (
            <TableCell key={`${index}-${colIndex}`} component="th" scope="row">
              <Skeleton animation="wave" variant="text" width="50%" />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </TableBody>
  );
};

export default TableRowsLoader;
